import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './i18n';
import './fonts.css';
import './index.css';
import { SessionProvider } from './session';

const container = document.getElementById('root');
if (!container) throw new Error('Root #root not found');
createRoot(container).render(
  <React.StrictMode>
    <BrowserRouter>
      <SessionProvider>
        <App />
      </SessionProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
